module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-margin-bottom"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("biz_title")) + " - "), _c('span', [_vm._v("商业IP")])]), _vm._v(" "), _c('div', {
    staticClass: "tx-page-subtitle"
  }, [_vm._v("专注于街区式商业物业投资与运营")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-style"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "projects.html",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "imgs/business/zyyw_ip2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 info-style"
  }, [_c('h4', [_vm._v("专注商街，共生烟火")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text_jj"
  }, [_vm._v("专注于特色商业街区，一般规模在2-3万㎡，通过前期策划、工程改造，品牌导入，运营推广等方式，创造风格鲜明的主题场景，打造以“交往”与“我们”为内涵的体验式商街。与商家共成长，与社区共呼吸，与业主共未来。")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text_a"
  }, [_c('a', {
    attrs: {
      "href": "projects.html",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")])])]), _vm._v(" "), _c('video', {
    staticClass: "video_xj",
    attrs: {
      "width": "100%",
      "controls": "controls",
      "preload": "none",
      "poster": "imgs/business/gbwh_mp4bg.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "imgs/business/gbwh_mp4.mp4",
      "type": "video/mp4"
    }
  }), _vm._v("\n            很抱歉，您的浏览器不支持观看此视频。\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-style",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "src": "imgs/business/gbwh1.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e68f25f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/business_two.vue
// module id = 107
// module chunks = 4